import ShopView from "./shop";
export default ShopView;
